module.exports = __webpack_public_path__ + "img/Yahoo_2019.f1e6cc38.svg";